import { Component } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService,
    Ticket,
    TicketsService,
    User,
    TransferRecipient
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the DisplayMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'text-tickets',
    templateUrl: 'text-tickets.html'
})
export class TextTicketsComponent extends BaseComponent {

    tickets: Ticket[];
    user: Promise<User>;
    cid: number;
    receiptFlag: boolean;
    dbName: string = "";
    mobileNumber: string = "";

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected ticketsService: TicketsService,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "TextTicketsComponent"
        );
    }

    ngOnInit() {
        this.user = new Promise<User>((resolve, reject) => {
            resolve(JSON.parse(this.localStorageService.get('user')) as User);
        });

        this.user.then((user) => {
            this.mobileNumber = user.MobileNumber;
        });

        this.cid = this.navParams.get('confirmationID') || null;
        this.receiptFlag = this.navParams.get('sendReceiptFlag');
        this.dbName = this.navParams.get('dbName') || "";
        this.tickets = this.navParams.get('tickets') || [];
    }

    textTickets() {
        this.user.then((user) => {
            this.tickets.forEach((ticket) => {
                ticket.OwnerID = this.notificationsService.loggedInUser.OwnerID;
            });

            const recipient = {} as TransferRecipient;
            recipient.CustomerID = user.CustomerID;
            recipient.MobileNumber = this.mobileNumber;
            recipient.FirstName = user.FirstName;
            recipient.LastName = user.LastName;
            
            this.ticketsService.transferTickets(recipient, this.tickets, this.cid, this.receiptFlag, "text", this.dbName)
                .subscribe((value) => {
                    if (value && value.ResultFlag && !value.ResultMessage) {
                        this.showNotification("Text successful.", undefined, undefined, "success");
                        this.cancel();
                    } else if (value && !value.ResultFlag && value.ResultMessage && value.ResultMessage.length > 0) {
                        this.showNotification(value.ResultMessage, undefined, undefined, "error");
                    }
                });
        });
    }

    cancel() {
        this.viewCtrl.dismiss();
    }

    buttonClicked(button: { text: string, tag: string }) {
        this.viewCtrl.dismiss({
            button
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/text-tickets/text-tickets.ts